import React from 'react'
import { GroupedSelectGroup } from './GroupedSelectGroup'
import { ItemGroup } from './types'

interface Props {
  data: ItemGroup[]
  selectedIds: string[]
  onToggle: (id: string) => void
}

export const GroupedSelectList: React.FC<Props> = ({ data, selectedIds, onToggle }) => (
  <>
    {data.map((group, idx) => (
      <GroupedSelectGroup
        key={group.title}
        title={group.title}
        icon={group.icon}
        items={group.items}
        selectedIds={selectedIds}
        onToggle={onToggle}
        showDivider={idx < data.length - 1}
      />
    ))}
  </>
)
